<template>
  <div>
      <!-- 头部 -->
      <top></top>
      <el-row class="exmain">
        <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
        <el-col :xs="5" :sm="4" :md="5" :lg="4" :xl="3">
          <div class="main-left">
            <p :class="[current==index?'active':'']" v-for="(item, index) in leftMenu" :key="index" @click="changeNav(index)">
              <span v-if="langSet == 'zh'">{{item.ch}}</span>
              <span v-if="langSet == 'en'">{{item.en}}</span>
            </p>
          </div>
        </el-col>
        <el-col :xs="16" :sm="18" :md="14" :lg="13" :xl="10">
          <div class="main-right">
            <international @show-demand="showDemand" @show-details="showDetails" ref="child"></international>
          </div>
        </el-col>
        <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
      </el-row>
      <frame v-if="isShowDemand" @close-frame="closeFrame" @reload="reloadPage" :qyid="0" :cpid="0"></frame>
      <busDetail v-if="isShowDetails" :detailsId="detailsId" @close-details="closeDetails"></busDetail>
      <personalData v-if="isShowPersonalData" @close-personal="closePersonal"></personalData>
      <!-- 底部 -->
      <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import international from "./components/international.vue";
import frame from "./components/frame.vue";
import busDetail from "./components/busDetail.vue";
import personalData from "./components/personalData.vue";
import { getUser } from "@/api/api";
export default {
  components: {
    top,
    bottom,
    international,
    frame,
    busDetail,
    personalData
  },
  name: "business",
  data() {
    return {
      leftMenu:[
        {
          ch: '中国国内贸易',
          en: 'Trade (within China)'
        },
        {
          ch: '国际贸易',
          en: 'International Trade'
        }
      ],
      current: 1,
      isShowDemand: false,
      isShowDetails: false,
      isShowPersonalData: false,
      langSet: ''
    };
  },
  created() {
  },
  mounted() {
    this.langSet = localStorage.getItem('languageSet') || 'zh';
    this.memberid = localStorage.getItem('memberid');
    this.uuid = localStorage.getItem('uuid');
    this.list = this.$refs.child.list;
  },
  methods: {
    changeNav(index){
      if(index == 0){
            this.$router.push({path: '/business'});
        }
    },
    showDemand(data){
      //console.log(data)
      this.getData();
    },
    showDetails(data){
      //console.log(data)
      this.detailsId = data;
      if(this.detailsId > 0){
        this.isShowDetails = true;
      }
    },
    closeFrame(data){
      this.isShowDemand = data;
    },
    closeDetails(data){
      this.isShowDetails = data;
    },
    reloadPage(data){
      if(data){
        this.$router.go(0)
      }
    },
    closePersonal(data){
      this.isShowPersonalData = false;
    },
    getData(){
      let data = this.$qs.stringify({
          memberid: this.memberid,
          uuid:this.uuid
      })
      getUser(data).then(res=>{
          if(res.data.errno == 0){
            this.userInfo = res.data.rst;
            this.nickname = res.data.rst.nickname;
            this.mobile = res.data.rst.mobile;
            this.email = res.data.rst.email;
            this.companyName = res.data.rst.companyName;
            this.industryName = res.data.rst.industryName;
            this.industryId = res.data.rst.industry;
            this.departmentId = res.data.rst.department;
            this.departmentName = res.data.rst.departmentName;
            this.dutiesId = res.data.rst.duties;
            this.dutiesName = res.data.rst.dutiesName;
            if (res.data.rst.companyName != '' && res.data.rst.departmentName != '' && res.data.rst.dutiesName != '' && res.data.rst.industryName != '' && res.data.rst.companyName != null && res.data.rst.departmentName != null && res.data.rst.dutiesName != null && res.data.rst.industryName != null){
              this.isShowPersonalData = false;
              this.isShowDemand = true;
            }else{
              this.isShowPersonalData = true;
              this.isShowDemand = false;
            }
          }
      }).catch(err=>{
          console.log(err)
      })
    },
  }
};
</script>

<style lang="scss">

</style>